<template>
<v-form ref="form">
                    <v-row>
                        <v-col>
                            <v-text-field
                            label="Business Name"
                            dense
                            outlined
                            v-model="name"
                            :rules="businessNameRules"
                            ></v-text-field>
                            <v-text-field
                            label="Business Facebook URL"
                            dense
                            placeholder="yourhandle"
                            outlined
                            v-model="facebook"
                            :hint="`e.g. ${urlPrefixes.facebookUrlPrefix}pappyon`"
                            >
                                <template v-slot:prepend-inner>
                                    <v-icon>mdi-facebook</v-icon>
                                    <div class="ml-1 mr-n1 mt-1">{{urlPrefixes.facebookUrlPrefix}}</div>
                                </template>
                            </v-text-field>
                            <v-text-field
                            dense
                            class="mt-3"
                            label="Business Instagram URL"
                            placeholder="yourhandle"
                            outlined
                            v-model="instagram"
                            :hint="`e.g. ${urlPrefixes.instagramUrlPrefix}pappyon`"
                            >
                                <template v-slot:prepend-inner>
                                    <v-icon>mdi-instagram</v-icon>
                                    <div class="ml-1 mr-n1 mt-1">{{urlPrefixes.instagramUrlPrefix}}</div>
                                </template>
                            </v-text-field>
                            <v-text-field
                            dense
                            class="mt-3"
                            label="Business Twitter URL"
                            placeholder="yourhandle"
                            outlined
                            v-model="twitter"
                            :hint="`e.g. ${urlPrefixes.twitterUrlPrefix}pappyon`"
                            >
                                <template v-slot:prepend-inner>
                                    <v-icon>mdi-twitter</v-icon>
                                    <div class="ml-1 mr-n1 mt-1">{{urlPrefixes.twitterUrlPrefix}}</div>
                                </template>
                            </v-text-field>
                            <v-text-field
                            dense
                            class="mt-3"
                            label="Business Linkedin URL"
                            placeholder="yourhandle"
                            outlined
                            v-model="linkedin"
                            :hint="`e.g. ${urlPrefixes.linkedinUrlPrefix}pappyon`"
                            >
                                <template v-slot:prepend-inner>
                                                <v-icon>mdi-linkedin</v-icon>
                                    <div class="ml-1 mr-n1 mt-1">{{urlPrefixes.linkedinUrlPrefix}}</div>
                                </template>
                            </v-text-field>
                        </v-col>
                    </v-row>
</v-form>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import Utility from '@/shared/utility';

export default {
    name: 'BusinessDetailsEditor',
    data() {
      return {
        isFirstSubmissionAttempt: true,
        selectedTelephoneCode: {countryCode: 'AU', number: '+61'},
        name: '',
        website: '',
        facebook: '',
        instagram: '',
        twitter: '',
        linkedin:'',
        items: ['General Details', 'Main Business Address', 'Social Media Accounts'],
        phoneNumberRules: [
            v => !!v || 'This field is required',
            v => /^\d+$/.test(v.replaceAll(' ', ''))||'Invalid phone number'
        ],
        businessNameRules: [
            v => !!v || 'Please enter your Business Name',
        ],
      }
    },
    computed: mapGetters(['businessProfile', 'telephoneCodes', 'urlPrefixes']),
    props: {
        bus: {}
    },
    watch: {
        facebook: function(newVal, oldVal) { 
            if(newVal.startsWith(this.urlPrefixes.facebookUrlPrefix)) {
                this.facebook = this.facebook.replace(this.urlPrefixes.facebookUrlPrefix, "");
            }
        },
        instagram: function(newVal, oldVal) { 
            if(newVal.startsWith(this.urlPrefixes.instagramUrlPrefix)) {
                this.instagram = this.instagram.replace(this.urlPrefixes.instagramUrlPrefix, "");
            }
        },
        twitter: function(newVal, oldVal) { 
            if(newVal.startsWith(this.urlPrefixes.twitterUrlPrefix)) {
                this.twitter = this.twitter.replace(this.urlPrefixes.twitterUrlPrefix, "");
            }
        },
        linkedin: function(newVal, oldVal) { 
            if(newVal.startsWith(this.urlPrefixes.linkedinUrlPrefix)) {
                this.linkedin = this.linkedin.replace(this.urlPrefixes.linkedinUrlPrefix, "");
            }
        },
        // name: function (newValue) {
        //     var splitStr = newValue.split(' ');
        //     for (var i = 0; i < splitStr.length; i++) {
        //         splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);     
        //     }
        //     this.name = splitStr.join(' '); 
        // }
    },
    created() {
        this.getTelephoneCodeFromCountry = Utility.getTelephoneCodeFromCountry;
    },

    mounted() {
        this.bus.$on('initEditor', this.initEditor);
        this.initEditor();
    },
    methods: {
        ...mapActions(['updateBusinessProfileDetails']),
        initEditor() {
            this.name = this.businessProfile.businessName || '';
            this.website = this.businessProfile.websiteURL || '';

            this.facebook = this.businessProfile.facebookURL || '';
            this.instagram = this.businessProfile.instagramURL || '';
            this.twitter = this.businessProfile.twitterURL || '';
            this.linkedin = this.businessProfile.linkedinURL || '';
        },

        async onSave() {
            if (this.$refs.form.validate()) {
                try {
                    await this.updateBusinessProfileDetails({
                    businessName: this.name,
                    websiteURL: this.website,
                    facebookURL: this.facebook,
                    instagramURL: this.instagram,
                    twitterURL: this.twitter,
                    linkedinURL: this.linkedin,
                    countryPhoneCode: this.selectedTelephoneCode.countryCode,
                    countryPhoneCodeNumber: this.selectedTelephoneCode.number,
                    });
                }
                catch(error) {
                    console.log("Error updating the business profile details" + error);
                };
                return true;
            }
            return false;
        },
        filterTelephoneCodeAutocompleteBox(item, queryText, itemText) {
            if(item.name.toUpperCase().includes(queryText.toUpperCase()) || itemText.toUpperCase().includes(queryText.toUpperCase()))
                return true;
            else
                return false;
        },
    }
}
</script>